import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseHandleErrorService } from '../../../commons/services/base-handle-error.service';
import { BaseHttpClientService } from '../../../commons/services/base-http-client.service';
import { environment } from '../../../../environments/environment';
import { AuthConstants } from '../contants/auth-constants';
import { LoginResponseModel } from '../models/login-response.model';
import { ResponseModel } from '../../../commons/models/response-model';
import { LoginModel } from '../models/login-model';
import { GetFederatedTokenModel } from '../models/auth-federated-token-model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private _httpClientService: BaseHttpClientService,
    private _handleErrorHelper: BaseHandleErrorService,
    private _httpClient: HttpClient,
  ) {
  }

  public internalLogin(login: LoginModel): Observable<ResponseModel<LoginResponseModel>> {
    return this._httpClientService.sendPostRequestCredentials(AuthConstants.ExternalAuthUrl, login, false, environment.restApi.msB2C, false, login.country).pipe(
      map( response => {
        return response;
      }), catchError((error: HttpErrorResponse) => this._handleErrorHelper.handleError(error))
    )
  }
  public getAuthCodeUrl(idp:string,isLogin:boolean): Observable<ResponseModel<string>> {


    return this._httpClientService.sendGetRequestParameters(AuthConstants.FederatedUrlCodePath,idp+'&'+isLogin+'&'+environment.country, false, environment.restApi.msB2C,'2').pipe(
      map( response => {
        return response;
      }), catchError((error: HttpErrorResponse) => this._handleErrorHelper.handleError(error))
    )
  }
  public getFederatedToken(getFederatedTokenModel:GetFederatedTokenModel): Observable<ResponseModel<string>> {
    return this._httpClientService.sendPostRequest(AuthConstants.FederatedLoginPath, getFederatedTokenModel,false, environment.restApi.msB2C,false,'5').pipe(
      map( response => {
        return response;
      }), catchError((error: HttpErrorResponse) => this._handleErrorHelper.handleError(error))
    )
  }
}
